// extracted by mini-css-extract-plugin
export default {"container":"UploadPage_container__gzs6O","title":"UploadPage_title__FqQCk"};